module.exports = __webpack_public_path__ + "static/media/Niveau_elN11_4_517699.ae999773.png";